export default __webpack_public_path__ + "static/media/Magadhi_fina_f.15687b5d.wav";